namespace('arctic.views.individual');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.PoliciesWidget');
compass.require('compass.hotel.CancelRoomWidget');


compass.require('compass.demographic.IndividualFormsWidget');
compass.require('compass.demographic.DupeSelectWidget');

compass.requireLib('compass.util.tracking');

arctic.views.individual.individualPaymentRequired = function(viewport,options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('individualPaymentRequiredView');

	var me = this;

	var _viewport = viewport;
	var d = jQuery.dom;
	var $j = jQuery;

	var _settings = options;
	var _validator;
	var _data;

	var _ids = {
		contact: compass.generateId(),
		payment: compass.generateId(),
		requests: compass.generateId(),
		shares: compass.generateId(),
		policies: compass.generateId()
	};

	var _stayRecapWidget, _individualFormsWidget;

	var _render = function() {
		_viewport.append(d.div({ className : 'individualPaymentRequired' },
			d.h2(
				d.reader('Payment Required – complete form and submit to complete reservation')
			),
			d.div({ className: 'individualFormsContainer' }),
			d.div({ className : 'stayRecapMain' }, d.reader(d.h2('Reservation Summary'))),
			d.div({className : 'clear'})
		));
		compass.loading.stop();
	};

	var _showPoliciesPopup = function(viewdata) {
		jQuery.ajax({
			data: { blocked_room_id: viewdata.blockedRoomId },
			dataType:'json',
			traditional: true,
			url:'/policies', success : function(data) { var policiesDiv = d.div({className:'policiesContainer'}); _policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
						WUID : 'policiesWidget_individualPersonalInfo',
						policies: data
					});

				_policiesDialog = d.dialog({
					classes: 'personalInfo policiesDialog',
					contents: policiesDiv,
					dialogId: _ids.policies,
					centerOnView: true
				});
			}
		});
	};


	var _handleCancel = function (event, data) {
		var cancelDialogId = data.dialogId || '';
		var container = d.div();
		var cancelValidator = new compass.validator({
					onValid : function (e) { e.removeClass('invalid'); },
					onInvalid: function (e) { e.addClass('invalid'); }
				});
		var cancelWidget = new compass.hotel.CancelRoomWidget(container, {
									cancelFee : 0,
									currencyFormatter : _settings.meetingInfo.defaultCurrencyFormatter,
									validator: cancelValidator,
									cancelReasons : _data.cancelReasons
								});

		var cancelButton = cancelWidget.getCancelButton();
		var checkbox = cancelWidget.getCheckbox();
		checkbox.addClass('disabled');

		cancelWidget.bind('CancelRoomWidget.cancelFeeCheckboxChanged', function(event) {
			if (checkbox.length > 0 && checkbox.is(":checked")) {
				checkbox.removeClass('invalid');
				cancelButton.removeClass('disabled');
			} else if (checkbox.length > 0) {
				checkbox.addClass('invalid');
				cancelButton.addClass('disabled');
			} else {
				return;
			}
		});

		cancelWidget.bind('CancelRoomWidget.cancelReasonsChanged', function(event, values) {
			var values = cancelWidget.getValues();
			if (values.reason >= 0 && (checkbox.is(":checked") || checkbox.length === 0)) {
				cancelButton.removeClass('disabled');
			}
		});

		cancelWidget.bind('CancelRoomWidget.Cancel', function (event, data) {
			data.housing_id= _data.reservations[0].reservation.housingId;

			var fields = cancelValidator.validate();
			if (fields.length > 0) {
				return;
			}

			jQuery.ajax({
				url: '/actCancel',
				type: 'POST',
				data: data,
				success: function(data) {
					cancelDialog.close();
					jQuery.ajax({
						url : '/sendConfirmation',
						success : function(data) {
							_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
						}
					});
				}
			});
		});

		var cancelDialog = d.dialog({
			contents: container,
			classes: "individualFrontDesk CancelDialog",
			showParent: true,
			idGenerator: compass.generateId,
			dialogId: cancelDialogId
		});
	};

	
	
	var _setupWidgets = function(viewdata) {

		var onFormSubmit = function(formData, onFinishSubmit) {
			var actPaymentRequiredData = {
				housing_id: viewdata.reservations[0].reservation.housingId,
				blocked_room_id: viewdata.reservations[0].reservation.blockedRoomId,
				payment_info: formData.PaymentWidget,
				requests: formData.RoomRequestsWidget,
				shares: formData.RoomSharesWidget,
				frequentGuestNumber: formData.frequentGuestNumberWidget,
				policiesCheckbox: _viewport.find('.policiesCheckbox').prop('checked')
			};
			jQuery.ajax({
				url : '/actPaymentRequired',
				data : JSON.stringify(actPaymentRequiredData),
				type : 'POST',
				contentType : 'application/json',
				success : function(data) {
					if ( data.success ) {
						jQuery.ajax({
						url : '/sendConfirmation',
							success : function(data) {
								compass.util.tracking.exactTargetConversion();
								compass.util.tracking.googleConversion();
							}
						});
						jQuery('.forms').trigger(CompassEvents.Navigate, 'frontDesk');
						$j('body').trigger(CompassEvents.Login, data.loginInfo);
						$j('body').css({cursor : 'inherit'});

					} else {
						if (data.policiesCheckboxChecked === false) {
							d.alert("Please agree to the hotel policies before continuing.");
						} else {
					 		alert ('Problem creating record.');
						}
					}
					onFinishSubmit();
				}
			});
		};

		/* viewdata.reservations is coming from getReservationCost when it should be coming from getBookedReservationCost like the group side is. 
		   this should be fixed at some point. This was discovered during charging, but there is not adequate time to address.
		   If a developer finds rate information is wrong on payment required this is why. 
		*/
		var recaps = _.filter(_.pluck(viewdata.reservations,'stayRecap'), function(e,i){
																return e.depositWillBeCharged;
				  	 });


		var minChargingDate = _.min(recaps,function(e){ return Number(e.depositWillBeChargedAt.split('-').join(''));}).depositWillBeChargedAt;

		var	chargingInfo = {
			hasCharging : _.some(viewdata.reservations, function(r){return (r.stayRecap.depositWillBeCharged);}),
			chargingToday : _.some(viewdata.reservations, function(r){
																		return (r.stayRecap.depositWillBeCharged && r.stayRecap.depositWillBeChargedTodayOrEarlier);
																	}),
			chargingFirstDate : (minChargingDate && minChargingDate.length > 0 ? compass.util.parse.ISODateParser(minChargingDate) : '')
		};



		_individualFormsWidget = new compass.demographic.IndividualFormsWidget(_viewport.find('.individualFormsContainer'), {
			WUID : 'individualFormsWidget',
			meetingInfo : _settings.meetingInfo,
			blockedRoomId : viewdata.blockedRoomId,
			commonRequests : viewdata.commonRequests,
			countriesAndStates : viewdata.countriesAndStates,
			extraRequiredFields : viewdata.extraRequiredFields,
			individualInfo : viewdata.individualInfo,
			paymentOptions : viewdata.paymentOptions,
			reservations : viewdata.reservations,
			validIndividualHousing : viewdata.validIndividualHousing,
			onFormSubmit : onFormSubmit,
			ids : _ids,
			chargingInfo : chargingInfo,
			paymentRequired : true
		});

		_stayRecapWidget = new compass.hotel.StayRecapWidget(_viewport.find('.stayRecapMain'), {
			WUID : 'stayRecapWidget_individualPersonalInfo',
			recapArray : viewdata.reservations,
			meetingInfo: _settings.meetingInfo,
			chargingInfo: viewdata.chargingInfo
		});

		_stayRecapWidget.bind('StayRecapWidget.showPolicies', function () {
			compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Personal Info - Receipt');
			_showPoliciesPopup(viewdata);
		});


		_viewport.find(".policiesLink").activate(function(){
			compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Personal Info - Agree Link');
			_showPoliciesPopup(viewdata);
		});

		_viewport.find(".stayRecapMain").append(d.div({className : 'stayRecapShadow'}));

		var cancelRoomsDialogId = compass.generateId();
		_individualFormsWidget.find(".cancelReservations").bind('click', function(evt){_handleCancel(evt, {dialogId: cancelRoomsDialogId})});
		
		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});
	};

	this.run = function(renderComplete) {
		compass.loading.start();
		_settings.meeting_code = compass.matchDict.meetingCode;
		jQuery.ajax({
			url : '/paymentRequired',
			success : function(data) {
				_settings.countriesAndStates = data.countriesAndStates;
				_data = data;
				_render();
				_setupWidgets(data);

				compass.loading.stop();
				renderComplete();
			}
		});
	};
};

